import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import AlertRequestBody from "./AlertsRequestBody";

export default class AlertsService {
    request = new AlertRequestBody();
    static shared = new AlertsService();

    alertsListRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getAllAlerts(payload),
              this.request.alertsListRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      } 
}